<template>
  <div v-if="personData" @keyup.enter="signUp" class="mt-6 p-lg-6 p-3">
    <h3 class="text-secondary font-weight-light text-center">{{ $t("common.welcome_screen.complete_basic_information") }}</h3>
    <input
      :value="personData.firstName"
      @input="updateValues('firstName')"
      :placeholder="$t('common.welcome_screen.first_name')"
      ref="firstNameInput"
      type="text"
      class="form-control"
      autofocus
    >
    <input
      :value="personData.lastName"
      @input="updateValues('lastName')"
      :placeholder="$t('common.welcome_screen.last_name')"
      ref="lastNameInput"
      type="text"
      autocomplete="current-password"
      class="form-control mt-2"
    >

    <button
      @click="completeProfile"
      class="btn btn-sm btn-primary mt-2 mt-2 float-right"
    >
      {{ $t("common.welcome_screen.create_account") }}
      <i class="fe fe-arrow-right"></i>
    </button>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';
  export default {
    name: 'AccountSetupStep',
    mixins: [AuthStepsMixin],
    computed: {
      ...mapGetters([
        'account',
      ]),
    },
    methods: {
      completeProfile: function () {
        const firstName = this.$refs.firstNameInput.value;
        const lastName = this.$refs.lastNameInput.value;
        if (firstName.length) {
          const updatedAccount = this.account;
          updatedAccount.first_name = firstName;
          updatedAccount.last_name = lastName;
          this.$store.dispatch('updateAccount', updatedAccount);
          window.fbq('track', 'CompleteRegistration');
          this.emitStep('selectWorkspace');
        } else {
          this.$refs.firstNameInput.focus();
        }
      },
    },
  };
</script>

<style scoped>

</style>
